<template>
  <div class="queue-header" @click="toggleExpanded">
    <div class="header-content">
      <span class="icon">📁</span>
      <div class="info">
        <div class="title">{{ storageStore.queueHeaderTitle }}</div>
        <div class="progress-container">
          <div class="progress-bar">
            <div 
              class="progress-fill" 
              :style="{ width: `${storageStore.overallProgress}%` }"
            ></div>
          </div>
          <div class="progress-text">{{ storageStore.overallProgress }}%</div>
        </div>
      </div>
    </div>
    <div class="controls">
      <button
        class="expand-btn"
        :class="{ 'expanded': storageStore.queueUIExpanded }"
        @click.stop="toggleExpanded"
      >
        {{ storageStore.queueUIExpanded ? '▼' : '▲' }}
      </button>
      <button
        class="close-btn"
        @click.stop="closeQueue"
        :disabled="hasActiveQueue"
        :title="hasActiveQueue ? 'キューが実行中のため閉じることができません' : '閉じる'"
      >
        ✕
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStorageStore } from '@/stores/storageStore'

const storageStore = useStorageStore()

const hasActiveQueue = computed(() => {
  return storageStore.queueStats.pending > 0 || storageStore.queueStats.processing > 0
})

const toggleExpanded = () => {
  storageStore.toggleQueueUI()
}

const closeQueue = () => {
  if (!hasActiveQueue.value) {
    storageStore.hideQueueUI()
  }
}
</script>

<style scoped>
.queue-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s ease;
}

.queue-header:hover {
  background-color: #f8f9fa;
}

.header-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.icon {
  font-size: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.info {
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.progress-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-bar {
  flex: 1;
  height: 4px;
  background-color: #e9ecef;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  transition: width 0.3s ease;
  border-radius: 2px;
}

.progress-text {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  min-width: 35px;
  text-align: right;
}

.controls {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.expand-btn,
.close-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6c757d;
  transition: all 0.2s ease;
}

.expand-btn:hover,
.close-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.expand-btn.expanded {
  transform: rotate(0deg);
}

.close-btn {
  font-size: 14px;
  font-weight: bold;
}

.close-btn:hover:not(:disabled) {
  background-color: #dc3545;
  color: white;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #6c757d;
}

.close-btn:disabled:hover {
  background-color: transparent;
  color: #6c757d;
}
</style>